import styled, { css } from 'styled-components'
import { TmpThemeCustom } from '../../../themes/TmpThemeCustom';

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`

interface PropsButton {
  actived: boolean;
  theme: any;
}

export const Button = styled.button<PropsButton>`
  background: none;
  border: none;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  ${props => props.theme.dropdownButton}
  ${props => props.theme.motion}
 
  > .tmp-avatar {
    padding-right: 16px;
  }

  > .tmp-icon {
    .chevron__container{
      transform: translateY(13px);
      ${(TmpThemeCustom.motion)}
      transition-property: transform;
    }
    .chevron__line1,
    .chevron__line2{
      ${(TmpThemeCustom.motion)}
      stroke-width: 10;
      stroke-linecap: round;
      stroke: currentcolor;
      transform-origin: 50px 50px
    }
    .chevron__line1 {
      transform: rotate(40deg);
    }
    .chevron__line2 {
      transform: rotate(-40deg);
    }
    padding-left: 24px;
  }

  &:hover {
    background-color: rgba(197, 215, 251, 0.32);
    color: rgb(10, 58, 153);
    border-radius: 8px;
    cursor: pointer;
    span {
      color: rgb(10, 58, 153);
    }
  }

  ${props => props.actived && css`
  .tmp-icon {
      .chevron__container{
        transform: translateY(-13px);
      }
      .chevron__line1,
      .chevron__line2{

      }
      .chevron__line1 {
        transform: rotate(-40deg);
      }
      .chevron__line2 {
        transform: rotate(40deg);
      }
    }
    color: rgb(44, 110, 242);
    span {
      color: rgb(44, 110, 242);
    }
  `}

`

export const ButtonLabel = styled.div`
  flex-direction: column;
  align-items: flex-start;
  display: none;
  @media(min-width: 768px) {
    display: flex;
  }
`

export const ButtonName = styled.span`
  ${props => props.theme.dropdownButtonName}
`

export const ButtonAccount = styled.span`
  ${props => props.theme.dropdownButtonAccount}
`
interface PropsDropDown {
  actived: boolean;
}

export const DropDown = styled.ul<PropsDropDown>`
  position: fixed;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  z-index: 1000;

  display: none;
  opacity: 0;
  ${props => props.theme.dropdown}
  ${props => props.theme.motion}
  ${props => props.actived && css`
    display: block;
    opacity: 1;
  `}
  
  .tmp-list-item {
    border-color: transparent;
  }

  @media(min-width: 768px) {
    position: absolute;
    top: initial;
    left: initial;
    min-width: 100%;
    width: max-content;
    height: auto;
    ${ props => props.theme.dropdownList.tablet }
    .tmp-typography{
      display: none;
    }

    
  }
`